import React from 'react'

import SelectField from '~/components/Fields/SelectField'

const OPTIONS = [
]
function CompanyStatusField (props) {
  return (
    <SelectField
      name="status"
      label="Status"
      options={OPTIONS}
      {...props}
    />
  )
}

export default CompanyStatusField
